import { motion } from "framer-motion";
import { ReactNode } from "react";

interface ContainerAnimationProps {
  children: ReactNode;
  className?: string;
}

const ContainerAnimation = ({
  children,
  className,
}: ContainerAnimationProps) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {children}
    </motion.div>
  );
};

export default ContainerAnimation;
